import React from 'react';
import { 
  Container, 
  Banner, 
  Headline, 
  WingsLogo,
  CTAButton,
  OpenToWorkSeal,
  FooterText
} from './BannerStyle';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

import { Bio } from '../../data/constants';

const RKLogo = ({ size = 180, opacity = 1 }) => (
  <svg viewBox="0 0 100 100" width={size} style={{ opacity }}>
    {/* Clean Circle Frame */}
    <circle cx="50" cy="50" r="48" fill="none" stroke="white" strokeWidth="0.5" strokeOpacity="0.3" />
    {/* Signature RK Initials in Elegant Serif */}
    <text 
      x="50" 
      y="64" 
      fontSize="42" 
      fontWeight="100" 
      fill="#FFF" 
      textAnchor="middle" 
      fontFamily="'Playfair Display', serif"
      letterSpacing="-2"
    >
      RK
    </text>
  </svg>
);

const FooterBanner = () => {
  return (
    <Container>
      <Banner
        as={motion.div}
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        onClick={() => window.open('mailto:' + Bio.email, '_blank')}
      >
        <WingsLogo>
           <RKLogo />
        </WingsLogo>

        <Headline>
          FROM CONCEPT TO <br />
          <strong>CREATION.</strong> <br />
          <span>LET'S MAKE IT HAPPEN!</span>
        </Headline>

        <CTAButton>
          Get In Touch
          <div className="arrow">
             <ArrowRight size={16} />
          </div>
        </CTAButton>

        <OpenToWorkSeal>
          <div className="rotating-ring">
            <svg viewBox="0 0 100 100" width="100">
              <path id="circlePath" d="M 50, 50 m -40, 0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0" fill="none" />
              <text fill="rgba(133, 76, 230, 0.7)" fontSize="8.5" fontWeight="900" letterSpacing="2.5">
                <textPath href="#circlePath">
                  • OPEN TO WORK • OPEN TO WORK • OPEN TO WORK
                </textPath>
              </text>
            </svg>
          </div>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <RKLogo size={30} opacity={0.6} />
          </div>
        </OpenToWorkSeal>

        <FooterText>
           <p>Available for full time roles & freelance projects.</p>
           <span>Crafting high fidelity products and seamless experiences.</span>
        </FooterText>
      </Banner>
    </Container>
  );
};

export default FooterBanner;
